module.exports = __webpack_public_path__ + "img/1.84b0003d.jpg";